import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { DepartmentSchema } from '../../entities/department/department.schema';
export const ResolveDepartmentManagerRequestSchema = z.object({
    managerId: z.string()
});
export const ResolveDepartmentManagerResponseSchema = DepartmentSchema;
export const ResolveDepartmentManagerErrorSchema = BaseErrorSchema;

//# sourceMappingURL=resolve-department-manager.schema.js.map